/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pagination_Page_SizeInputs */

const cs_pagination_page_size = /** @type {(inputs: Pagination_Page_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na stránku`)
};

const en_pagination_page_size = /** @type {(inputs: Pagination_Page_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per page`)
};

/**
* | output |
* | --- |
* | "Per page" |
*
* @param {Pagination_Page_SizeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pagination_page_size = /** @type {((inputs?: Pagination_Page_SizeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagination_Page_SizeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagination_page_size(inputs)
	return cs_pagination_page_size(inputs)
});